// extracted by mini-css-extract-plugin
export default {"earn_page_wrapper":"Earn_earn_page_wrapper__tsDuU"};